import { render, staticRenderFns } from "./FixedTop.vue?vue&type=template&id=5a1c1883&scoped=true"
import script from "./FixedTop.vue?vue&type=script&lang=js"
export * from "./FixedTop.vue?vue&type=script&lang=js"
import style0 from "./FixedTop.vue?vue&type=style&index=0&id=5a1c1883&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1c1883",
  null
  
)

export default component.exports